import { render, staticRenderFns } from "./card-evento.vue?vue&type=template&id=9f0edbc0&scoped=true"
import script from "./card-evento.vue?vue&type=script&lang=js"
export * from "./card-evento.vue?vue&type=script&lang=js"
import style0 from "./card-evento.vue?vue&type=style&index=0&id=9f0edbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0edbc0",
  null
  
)

export default component.exports